<template>
  <div>
    <div class="paragraph-delimiter"></div>

    <p>
      Вітаємо! Ви молоді батьки або готуєтеся ними стати? У вас народилися малюки і
      вони ще не ходять до школи? А може ви – бабусі та дідусі і маєте веселих
      невгамовних онуків? Тоді вам точно до нас!
    </p>

    <div class="paragraph-delimiter"></div>

    <p>
      Українське дитяче онлайн-радіо RADIOKIDS.ONLINE – це насамперед соціальний
      проект, покликаний створити платформу для інтелектуального розвитку
      молодих сімей в Україні та підтримку сучасних освітніх програм для малюків з
      моменту народження та їх батьків, а також для тих, хто готується ними стати.
    </p>

    <div class="paragraph-delimiter"></div>

    <p>
      На вас чекає світла чарівна музика, велика база колискових з України та усього
      світу, якісний контент класичної музики для дітлахів, розвивальні передачі для
      вивчення іноземних мов, пізнавальні передачі «У світі тварин», казки,
      радіоспектаклі та літературні читання у співпраці з дитячими видавництвами
      України, українськими авторами та дитячими освітніми ініціативами.
    </p>

    <div class="paragraph-delimiter"></div>

    <p>
      Для молодих батьків ми підготували освітні передачі від провідних українських
      та зарубіжних фахівців про фізичний розвиток та виховання малюків,
      психологію батьківства. А також на Вас чекає передача «Мистецькі вітаміни» з
      неймовірною Мамою Дариною, яка ділитиметься з Вами цікавинками зі світу
      мистецтва і розповідатиме, на які культурні заходи можна піти батькам з
      малюками 0+ та дошкільнятами.
    </p>

    <div class="paragraph-delimiter"></div>
  </div>
</template>

<script>
export default {
  name: 'AboutUs'
}
</script>

<style lang="scss" scoped>
  @import "../../common.scss";
</style>



// WEBPACK FOOTER //
// src/components/Pages/AboutUs.vue